export default __webpack_public_path__ + "static/media/gallery36_3.c072dba2.png";